export class TypeWriter {
  queue = [];
  consuming = false;
  timmer;
  constructor(onConsume) {
    this.onConsume = onConsume;
  }
  // 输出速度动态控制
  dynamicSpeed() {
    const speed = 2e3 / this.queue.length;
    if (speed > 200) {
      return 200;
    } else {
      return speed;
    }
  }
  // 添加字符串到队列
  add(str) {
    if (!str) return;
    this.queue.push(...str.split(""));
  }
  // 消费
  consume() {
    if (this.queue.length > 0) {
      const str = this.queue.shift();
      str && this.onConsume(str);
    }
  }
  // 消费下一个
  next() {
    this.consume();
    this.timmer = setTimeout(() => {
      this.consume();
      if (this.consuming) {
        this.next();
      }
    }, this.dynamicSpeed());
  }
  // 开始消费队列
  start() {
    this.consuming = true;
    this.next();
  }
  // 结束消费队列
  done() {
    this.consuming = false;
    clearTimeout(this.timmer);
    this.onConsume(this.queue.join(""));
    this.queue = [];
  }
}
